import { createAsyncActionType } from './index';

export const GET_LEAD_DETAIL = createAsyncActionType(
  'leadDetail',
  'GET_LEAD_DETAIL'
);

export const UPDATE_LEAD_DETAIL = createAsyncActionType(
  'leadDetail',
  'UPDATE_LEAD_DETAIL'
);
